import { render } from "./room-history.vue?vue&type=template&id=13071630&scoped=true"
import script from "./room-history.vue?vue&type=script&lang=js"
export * from "./room-history.vue?vue&type=script&lang=js"

import "./room-history.vue?vue&type=style&index=0&id=13071630&lang=scss&scoped=true"

import exportComponent from "F:\\DEV\\estimationpoker\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13071630"]])

export default __exports__